import type { OwnStayIngredient } from '@apps/main/modules/recipe/ingredients/ownStayIngredient';

import {
  SearchTermType,
  SelectedHotelTypeQL,
} from '@libs/trip-planner-interfaces';
import type { HotelConstraintQL } from '@libs/trip-planner-interfaces';

import { isHotelIngredient } from '../../../recipe/ingredients';
import type { HotelIngredient } from '../../../recipe/ingredients';

export function adaptHotelIngredientToHotelConstraintQL(
  destination: HotelIngredient | OwnStayIngredient,
  maxNumberOfHotels = 1
): HotelConstraintQL {
  const constraint: HotelConstraintQL = {
    maxNumberOfHotels,
    selectedHotelTypes: [SelectedHotelTypeQL.Golf, SelectedHotelTypeQL.Ticket],
    boardBasis: [],
  };

  if (destination.searchTerm.type === SearchTermType.PolygonId) {
    const polygonId = isHotelIngredient(destination)
      ? destination.commonPolygon?.id ??
        destination.nearbyPolygon?.id ??
        destination.searchTerm.polygonId
      : destination.searchTerm.polygonId;

    return { ...constraint, polygonId };
  }

  if (destination.searchTerm.type === SearchTermType.HotelCode) {
    return { ...constraint, hotelCodes: [destination.searchTerm.hotelCode] };
  }

  constraint.destination = isHotelIngredient(destination)
    ? destination.commonPolygon?.name ??
      destination.nearbyPolygon?.name ??
      destination.searchTerm.freeText
    : destination.searchTerm.freeText;

  return constraint;
}
